<template>
	<div class="not-found-component">
		<div class="content">
			<h1>Oops!</h1>
			<h3>The page you're looking for is not here.</h3>
			<router-link :to="{ name: 'home' }"
				>Back to the home page</router-link
			>
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../styles/views/notFoundComponent.scss';
</style>
